// Minimal PostgREST GET helper that avoids importing supabase-js.
// Public read-only queries that run during initial page load (hero content,
// site settings, footer, widget-zone probe) use this so the vendor-supabase
// chunk stays out of the critical path entirely.
const SUPABASE_URL = import.meta.env["VITE_SUPABASE_URL"] as string;
const ANON_KEY = import.meta.env["VITE_SUPABASE_PUBLISHABLE_KEY"] as string;

export async function restGet<T = unknown>(path: string): Promise<T | null> {
  try {
    const res = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
      headers: {
        apikey: ANON_KEY,
        Authorization: `Bearer ${ANON_KEY}`,
        Accept: "application/json",
      },
    });
    if (!res.ok) return null;
    return (await res.json()) as T;
  } catch {
    return null;
  }
}